(() => {
  angular
    .module('complianceFrameworkApp.complianceForums')
    .controller('EditDiscussionController', EditDiscussionController);

  /* ngInject */
  function EditDiscussionController($state, $stateParams, Flash, sessionService, forumService, discussionService, formErrorsService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.forum = {};
    vm.discussion = {};
    vm.discussionForm = {};
    vm.getForum = getForum;
    vm.getDiscussion = getDiscussion;
    vm.updateDiscussion = updateDiscussion;

    vm.activate();

    function activate() {
      getForum();
      getDiscussion();
    }

    function getForum() {
      forumService(sessionService.getAuthToken()).get({slug: $stateParams.slug}, response => vm.forum = response);
    }

    function getDiscussion() {
      discussionService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => vm.discussion = response);
    }

    function updateDiscussion(discussion) {
      vm.clearFormErrors();
      discussionService(sessionService.getAuthToken()).update({id: vm.discussion.id, discussion}, _saveDiscussionSuccess, _saveDiscussionFailure);
    }

    function _saveDiscussionSuccess(_response) {
      $state.go('application.compliance_forums.show_discussion', { slug: vm.forum.slug, id: vm.discussion.id });
      Flash.create('success', 'The discussion was successfully updated.');
    }

    function _saveDiscussionFailure(response) {
      vm.setFormErrors(vm.discussionForm, response);
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors on the form and resubmission.');
    }
  }
})();
